import { NgModule } from '@angular/core';
import { MSAL_INSTANCE, MsalModule } from '@azure/msal-angular';
import { msalConfig, protectedResources } from '../auth.config';
import { InteractionType, PublicClientApplication } from '@azure/msal-browser';
import { msalInstance } from '../msal-instance';

@NgModule({
    imports: [
        MsalModule.forRoot(
            msalInstance,
            {
                interactionType: InteractionType.Redirect,
                authRequest: {
                    scopes: protectedResources.api.scopes
                }
            },
            {
                interactionType: InteractionType.Redirect,
                protectedResourceMap: new Map([
                    [protectedResources.api.endpoint, protectedResources.api.scopes]
                ])
            })
    ],
    exports: [MsalModule],
})
export class MsalAuthModule { }
